<template>
  <div>
    <el-dialog title="选择预约时间" :before-close="handleClose" width="100%" :visible.sync="showSelect" class="selectBox"
      :close-on-click-modal="false" :modal-append-to-body='false' top='30px' :append-to-body="true" center>
      <div class='dateBox'>
        <el-date-picker v-model="dateRange" @change="getSelectValue" type="daterange" value-format="yyyy-MM-dd" unlink-panels
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <el-table :data="tableData" border :cell-style="setColor" @cell-click="setSelect" :max-height="500">
        <el-table-column label="当天时间" align="right" width="150" fixed="left">
          <el-table-column prop="rowName" label="周天" width="150" fixed="left">
          </el-table-column>
        </el-table-column>
        <el-table-column v-for='(item, index) in  duringHeader ' :key='index' :prop="item" width="120" :label="item"
          align="center">
          <template slot-scope="scope">
            <p v-if="scope.row[item]">{{ scope.row[item].split('$$')[0] }}</p>
            <p v-if="scope.row[item]">{{ scope.row[item].split('$$')[1] }}</p>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button type="primary" @click="detail_save">选好了</el-button>
        <el-button @click="handleClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    showSelect: {
      default: false
    },
    eqId: {
      default: false
    },
    selectListcopy: {
      default: false
    },
    allowCrossDay: {
      default: false
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          let date = new Date(),
            year = date.getFullYear(),
            month = date.getMonth() + 1,
            strDate = date.getDate() - 1
          if (month < 10) month = `0${month}`
          if (strDate < 10) strDate = `0${strDate}`
          let textDate = `${year}-${month}-${strDate}`
          var startDatenum = new Date(textDate).getTime();
          return time.getTime() < startDatenum
        },
      },
      dateRange: [],
      selectList: [],
      ifcanAllline: false,
      startDate: '',
      endDate: '',
      duringHeader: [
      ],
      tableData: [
      ],
      minTime: '',
      maxTime: '',
    }
  },
  methods: {
    handleClose() {
      this.$emit('cancel')
    },
    getNowFormatDate(n, dateStatus, needSeconds, needDate) {
      if (needDate) {
        let date = new Date(needDate).getTime()
        return date
      }
      else {
        let date = new Date()
        n?date.setDate(date.getDate()+n):null
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let strDate = date.getDate() 
        let hour = date.getHours()
        let minutes = date.getMinutes()
        let Seconds = date.getSeconds()
        if (month < 10) month = `0${month}`
        if (strDate < 10) strDate = `0${strDate}`
        if (hour < 10) hour = `0${hour}`
        if (minutes < 10) minutes = `0${minutes}`
        if (Seconds < 10) Seconds = `0${Seconds}`
        let str = needSeconds ? `${year}-${month}-${strDate} ${hour}:${minutes}:${Seconds}` : `${year}-${month}-${strDate}`
        let dates = dateStatus ? str : new Date(str).getTime()
        return dates
      }

    },
    init() {
      this.dateRange[0] = this.getNowFormatDate(0, 1)
      this.dateRange[1] = this.getNowFormatDate(6, 1)
      this.startDate = this.getNowFormatDate(0, 1)
      this.endDate = this.getNowFormatDate(6, 1)
      this.ifcanAllline = this.allowCrossDay
      this.$net(`/sdau/deviceReservation/reservedList`, 'get', { equipmentId: this.eqId, startDate: this.startDate, endDate: this.endDate }).then(res => {
        this.duringHeader = res.data.titleList
        this.tableData = res.data.reservedDeviceList
        this.minTime = res.data.minInterval
        this.maxTime = res.data.maxAppointmentTime
        this.detailTableData()
        this.selectList = JSON.parse(JSON.stringify(this.selectListcopy))
        this.ifClearSelectList()
      })
    },
    getSelectValue() {
      if (this.dateRange) {
        this.startDate = this.dateRange[0]
        this.endDate = this.dateRange[1]
      }
      else {
        this.startDate = ''
        this.endDate = ''
      }
      this.$net(`/sdau/deviceReservation/reservedList`, 'get', { equipmentId: this.eqId, startDate: this.startDate, endDate: this.endDate }).then(res => {
        this.duringHeader = res.data.titleList
        this.tableData = res.data.reservedDeviceList
        this.minTime = res.data.minInterval
        this.maxTime = res.data.maxAppointmentTime
        this.detailTableData()
        this.ifClearSelectList()
      }).catch(error => {
        this.tableData = []
        this.selectList = []
      })
    },
    detailTableData() {
      this.tableData.forEach(item => {
        item.reservedList.forEach(item2 => {
          if (item2.reservationUserPhoneNubmer) {
            this.$set(item, item2.timeStr, item2.reservationUserName + '$$' + item2.reservationUserPhoneNubmer)
          }
          else {
            this.$set(item, item2.timeStr, item2.reservationUserName + '$$')
          }
        })
      })
    },
    ifClearSelectList() {
      if (this.selectList.length) {
        this.getNowFormatDate(0, 0, 0, this.selectList[0].date) < this.getNowFormatDate(0, 0, 0, this.dateRange[0]) || this.getNowFormatDate(0, 0, 0, this.selectList[this.selectList.length - 1].date) > this.getNowFormatDate(0, 0, 0, this.dateRange[1]) ? this.selectList = [] : null
      }
    },
    setSelect(row, column) {
      if (column.index != 0) {
        if (this.selectList.length == 0) {
          this.selectList.push({ time: column.label, date: row.date })
        }
        else if (this.selectList.length == 1) {
          this.selectList[0].date == row.date && this.selectList[0].time == column.label ? this.selectList.splice(0, 1) : this.disposeSelectData(column.label, row.date, false)
          this.selectDataSort()
        }
        else if (this.selectList.length == 2) {
          this.selectList.some(item => { return item.date == row.date && item.time == column.label }) ? this.selectList = [] : this.disposeSelectData(column.label, row.date, true)
          this.selectDataSort()
          this.selectList.splice(this.selectList.findIndex(item => item.longLengthNewadd === true) == 1 ? 2 : 1, this.selectList.findIndex(item => item.longLengthNewadd === true) == -1 ? 0 : 1)
          this.selectList.forEach(item => { item.longLengthNewadd ? delete item.longLengthNewadd : null })
        }

      }
    },
    disposeSelectData(cloumnTime, rowDate, ifNew) {
      this.selectList[0].date != rowDate && !this.ifcanAllline ? this.$message({ type: 'warning', message: '该设备不可跨天预约' }) : this.selectList.push({ time: cloumnTime, date: rowDate, longLengthNewadd: ifNew })
    },
    selectDataSort() {
      this.selectList.sort((a, b) => {
        return  this.getNowFormatDate(0, 0, 0, a.date + ' ' + a.time.split('~')[0]) - this.getNowFormatDate(0, 0, 0, b.date + ' ' + b.time.split('~')[0])
      })
    },
    setColor({ row, column, rowIndex, columnIndex }) {
      if (columnIndex != 0) {
        let ifSelect = false
        this.selectList.length ? ifSelect = !(this.getNowFormatDate(0, 0, 0, row.date + ' ' + column.label.split('~')[0]) < this.getNowFormatDate(0, 0, 0, this.selectList[0].date + ' ' + this.selectList[0].time.split('~')[0]) || this.getNowFormatDate(0, 0, 0, row.date + ' ' + column.label.split('~')[0]) > this.getNowFormatDate(0, 0, 0, this.selectList[this.selectList.length - 1].date + ' ' + this.selectList[this.selectList.length - 1].time.split('~')[0])) : null
        if (row.reservedList.map(item => { return item.timeStr }).includes(column.property)) {
          ifSelect ? (this.$message({ type: 'warning', message: '选择时间包含已预约时间，请重新选择' }), this.selectList = []) : null
          return `background:rgb(219, 94, 94);cursor: default`
        }
        else {
          if (this.getNowFormatDate(0, 0, 1) >= this.getNowFormatDate(0, 0, 0, row.date + ' ' + column.label.split('~')[1])) {
            ifSelect ? (this.$message({ type: 'warning', message: '当前时间之前不可选择' }), this.selectList = []) : null
            return `background:rgb(138 138 138 / 62%);cursor: default`
          }
          else {
            if (row.schedulingRuleLimitList.includes(column.property)) {
              ifSelect ? (this.$message({ type: 'warning', message: '选择时间包含设备不可预约时间，请重新选择' }), this.selectList = []) : null
              return `background:rgb(138 138 138 / 62%);cursor: default`
            }
          }
        }
        if (ifSelect) {
          return `background:rgb(76, 110, 184);cursor: pointer`
        }
        return `cursor: pointer`
      }
    },




    // gettimeHeader() {
    //   // 生成24h头
    //   let timeArr = []
    //   let needArr = []
    //   for (let i = 1; i <= 48; i++) {
    //     if (i % 2 != '0') {
    //       if ((i - 1) / 2 < 10) {
    //         timeArr.push('0' + (i - 1) / 2 + ':00')
    //       }
    //       else {
    //         timeArr.push((i - 1) / 2 + ':00')
    //       }
    //     }
    //     else {
    //       if ((i - 2) / 2 < 10) {
    //         timeArr.push('0' + (i - 2) / 2 + ':30')
    //       }
    //       else {
    //         timeArr.push((i - 2) / 2 + ':30')
    //       }
    //     }
    //   }
    //   for (let j = 0; j < timeArr.length; j++) {
    //     if (j != timeArr.length - 1) {
    //       needArr.push(timeArr[j] + '~' + timeArr[j + 1])
    //     }
    //     else {
    //       needArr.push(timeArr[j] + '~' + timeArr[0])
    //     }
    //   }
    //   return needArr
    // },
    getTimeLength() {
      if (this.selectList.length && this.selectList.length > 1) {
        let startTime = this.getNowFormatDate(0, 0, 0, this.selectList[0].date + ' ' + this.selectList[0].time.split('~')[0]); // 开始时间
        let endTime = this.getNowFormatDate(0, 0, 0, this.selectList[this.selectList.length - 1].date + ' ' + this.selectList[this.selectList.length - 1].time.split('~')[1]); // 结束时间
        let usedTime = endTime - startTime; // 相差的毫秒数
        let days = Math.floor(usedTime / (24 * 3600 * 1000)); //相差天数

        let leavel = usedTime % (24 * 3600 * 1000); // 计算天数后剩余的时间
        let hours = Math.floor(leavel / (3600 * 1000)); // 计算剩余的小时数

        let leavel2 = leavel % (3600 * 1000); // 计算剩余小时后剩余的毫秒数
        let minutes = Math.floor(leavel2 / (60 * 1000)); // 计算剩余的分钟数

        hours = days * 24 + hours
        minutes = hours * 60 + minutes

        return minutes
      }
      else if (this.selectList.length && this.selectList.length == 1) {
        return 30
      }
      else {
        return 0
      }
    },
    detail_save() {
      if (!this.getTimeLength()) {
        this.$message({
          type: 'warning',
          message: '请选择预约时间'
        })
        return
      }
      else {
        if (this.getTimeLength() > Number(this.maxTime)) {
          this.$message({
            type: 'warning',
            message: `该设备最大预约时间不超过${this.maxTime}分钟`
          })
          return
        }
      }
      this.$emit('submit', this.selectList, this.getTimeLength())
      this.$message({
        type: 'success',
        message: '选择成功'
      })
      this.handleClose()
    },
  },
  created() {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
::v-deep.dateBox {
  display: flex;
  margin-bottom: 20px;
  justify-content: center;

  .el-date-editor {
    width: 20%;
  }
}

::v-deep.selectBox {
  .el-dialog__header {
    border-bottom: 1px #d7dce0 solid;
    padding: 0 0;
    height: 56px;
    line-height: 56px;
    font-weight: 800;
    color: black;
    // color: rgb(76, 110, 184);

    .el-dialog__headerbtn {
      top: 16px;
      right: 16px;

      .el-dialog__close {
        font-size: 24px;
      }
    }
  }

  .el-table tr td {
    height: 60px;
  }
}

::v-deep .el-table th {
  overflow: initial;
}

::v-deep.el-table th>.cell {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 14px;
  color: #2e3444;
}

::v-deep.el-table thead tr:first-of-type th:first-of-type,
.el-table thead tr:nth-of-type(2) th:first-of-type {
  border-bottom: none;
  padding: 0;
}

::v-deep.el-table thead tr:last-of-type th:first-of-type:before {
  content: '';
  position: absolute;
  width: 1px;
  background-color: #ebeef5;
  display: block;
}

::v-deep.el-table thead tr:last-of-type th:first-of-type:before {
  height: 183px; //根据情况调整
  bottom: 0;
  right: 0; //根据情况调整
  transform: rotate(-72deg); //根据情况调整
  transform-origin: bottom;
}

::v-deep.el-table tbody tr td:first-of-type .cell {
  font-family: PingFangSC-Regular, sans-serif;
  font-size: 14px;
  color: #2e3444;
  font-weight: 600;
  text-align: center;
}

.dateBox {
  >>>.el-table .cell {
    white-space: pre-line;
  }
}
</style>